/**
* Video Block
*
* All functionality related to the Video block.
*/

const Video = (function($) {

  // Selectors
  const _s = {
    container: '.wp-block-indp-video',
    cover: '.js-video-cover',
    playButton: '.js-video-play',
    embed: '.js-video-embed'
  };

  // Initialize
  const _init = function() {
    if (!$(_s.container).length) {
      return;
    }
    _bindEvents();
  };

  // Bind Events
  const _bindEvents = function() {
    $(document).on('click', _s.cover, function(e) {
      e.preventDefault();
      const $video = $(this).closest(_s.container);
      _playVideo($video);
    });
  };

  // Play video
  const _playVideo = function($video) {
    const $cover = $video.find(_s.cover);
    const $embed = $video.find(_s.embed);
    
    // Get video data from data attributes
    const videoService = $video.data('video-service');
    const videoId = $video.data('video-id');
    const videoUrl = $video.data('video-url');
    const videoType = $video.data('video-type');
    
    // Generate embed HTML based on service
    let embedHtml = '';
    
    if (videoService === 'youtube' && videoId) {
      embedHtml = `<iframe class="wp-block-indp-video__iframe" src="https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`;
    } else if (videoService === 'vimeo' && videoId) {
      embedHtml = `<iframe class="wp-block-indp-video__iframe" src="https://player.vimeo.com/video/${videoId}?autoplay=1" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>`;
    } else if (videoService === 'self-hosted' && videoUrl) {
      embedHtml = `<video class="wp-block-indp-video__video" controls autoplay><source src="${videoUrl}" type="${videoType}">Your browser does not support the video tag.</video>`;
    }
    
    // Insert embed HTML
    $embed.html(embedHtml);

    // Hide cover with fade out
    $cover.fadeOut(300, function() {
      $(this).remove();
    });

    // Show embed with fade in
    $embed.fadeIn(300);
  };

  // Return public API
  return {
    container: _s.container,
    init: _init
  };

})(jQuery);

export default Video;
